export enum Endpoint {
  PostLoginUserProfile = '/user/profile',
  IncrementLoginCount = '/user/increment_login',
  Signup = '/auth/signup',
  AcceptTerms = '/user/accept_tsncs',
  getAvailableClients = '/client',
  getUser = '/user',
  getClientConfig = '/client/config',
  getClientPropertyConfig = '/client/property_explorer_config',
  getUseCases = '/client/use-cases',
  getClientPreferences = '/client/preferences',
  getLayers = '/layer',
  // NOTICE: layerMetadata will be reestructured to use a dedicated endpoint once the API is evolving. Leave as is for now.
  layerMetadata = '/layer',
  getLayersFormatted = '/layer/formatted',
  getLayerDetails = '/layer/details',
  getLayersStyle = '/layer/styles',
  getClientWelcomeSidebarContent = '/client/welcome_sidebar_content',
  getSettings = '/settings',
  getLegends = '/legends',
  getStories = '/risk/stories/',
  acceptTermsAndConditions = '/user/accept_tsncs',
  markChangelogSeen = '/user/changelog_seen',
  getFeatureFlags = '/client/feature_flags',
  manageFeatureFlags = '/client/manage/feature_flags',
  getHomeContent = '/content',
  getAllGuideTabs = `/cms/main-tabs?populate=*&sort=order:asc`,
  getClientUsers = '/client/users',
  clientEmailDomains = '/client/email_domains',
  userInvite = '/user/invite',
  updateUserRole = '/user/update_user_roles',
  deleteUser = '/user/delete_user',
  resendInviteEmail = '/user/resend_invite_email',
  getSubTabByMainTopic = `cms/sub-tabs
  ?populate=main_topic
  &filters[main_topic][slug][$eq]=knowledge-base
  &sort=order:asc`,
  riskWorkspaces = '/workspaces',
  userCustomRoles = '/user/roles',
  layerPermissions = '/layer/permissions',
  datasetList = '/dataset',
  datasetUpload = '/dataset/upload',
  datasetUploadMultipartInitiate = '/dataset/upload/multipart/initiate',
  datasetUploadMultipartComplete = '/dataset/upload/multipart/complete',
  datasetUploadMultipartAbort = '/dataset/upload/multipart/abort',
  datasetUpdateMultipartInitiate = '/dataset/update/multipart/initiate',
  datasetUpdateMultipartComplete = '/dataset/update/multipart/complete',
  datasetUpdateMultipartAbort = '/dataset/update/multipart/abort',
  datasetElementConfig = '/dataset/element-config',
  getRegions = '/regions',
  riskProfile = '/risk-profile',
  riskProfileSummary = '/risk-profile/summary',
  riskProfileProperties = '/risk-profile/properties', // AKA social/economic
  documents = '/evidence/documents',
  documentsUploadInitiate = '/evidence/documents/upload/initiate',
  documentsUploadComplete = '/evidence/documents/upload/complete',
  documentsUploadAbort = '/evidence/documents/upload/abort',
}
